import { registerApplication, start } from 'single-spa'
import * as isActive from './activity-functions'

registerApplication(
  'header-microfrontend',
  () => System.import('header-microfrontend'),
  isActive.header,
  { domElement: document.getElementById('header') } // this maps to the <body> in index.ejs
)

registerApplication(
  'auth-microfrontend',
  () => System.import('auth-microfrontend'),
  isActive.auth,
  { domElement: document.getElementById('auth') }
)

registerApplication(
  'user-task-list-microfrontend',
  () => System.import('react-components'),
  isActive.components,
  {
    domElement: document.getElementById('user-task-list'),
    componentToShow: 'user-task-list'
  }
)

registerApplication(
  'requests-microfrontend',
  () => System.import('requests-microfrontend'),
  isActive.requests,
  { domElement: document.getElementById('requests-flow') }
)

registerApplication(
  'user-management-microfrontend',
  () => System.import('user-management-microfrontend'),
  isActive.user,
  { domElement: document.getElementById('user-management') }
)

registerApplication(
  'sharing-microfrontend',
  () => System.import('sharing-microfrontend'),
  isActive.sharing,
  { domElement: document.getElementById('shares') }
)

registerApplication(
  'profile-picker-microfrontend',
  () => System.import('profile-picker-microfrontend'),
  isActive.profilePicker,
  { domElement: document.getElementById('profiles') }
)

registerApplication(
  'search-microfrontend',
  () => System.import('search-microfrontend'),
  isActive.search,
  { domElement: document.getElementById('search') }
)

registerApplication(
  'cancer-microfrontend',
  () => System.import('cancer-microfrontend'),
  isActive.cancer,
  { domElement: document.getElementById('cancer') }
)

start()
